/**
 * Duracao: ler o que a pessoa digitou, e mostrar de volta em `1h 30m`.
 *
 * A API fala MINUTOS INTEIROS, sempre. Float de horas volta errado do
 * round-trip -- 0,1h nao e seis minutos na cabeca de ninguem, e a soma de um
 * mes deriva --, e por isso a conversao acontece aqui, uma vez, na borda.
 *
 * O parser aceita as cinco formas que as pessoas realmente digitam numa folha
 * de horas. Exigir um formato so e como se ensina o time a odiar a sexta-feira
 * a tarde.
 */

const MAXIMO_MINUTOS = 24 * 60;

/**
 * `1:30` · `1,5` · `1.5` · `90m` · `1h30` · `1h` · `90`
 *
 * @returns {number|null} minutos, ou null quando nao da para entender
 */
export function parsarDuracao(entrada) {
    if (entrada === null || entrada === undefined) {
        return null;
    }

    const texto = String(entrada).trim().toLowerCase().replace(/\s+/g, '');

    if (texto === '') {
        return null;
    }

    // `1:30`
    let m = texto.match(/^(\d{1,2}):([0-5]\d)$/);

    if (m) {
        return valido(Number(m[1]) * 60 + Number(m[2]));
    }

    // `1h30`, `1h30m`, `1h`
    m = texto.match(/^(\d{1,2})h(?:([0-5]?\d)m?)?$/);

    if (m) {
        return valido(Number(m[1]) * 60 + Number(m[2] ?? 0));
    }

    // `90m`
    m = texto.match(/^(\d{1,4})m$/);

    if (m) {
        return valido(Number(m[1]));
    }

    // `1,5` ou `1.5` -- horas decimais. A virgula vem primeiro porque e o que
    // o teclado brasileiro produz.
    m = texto.match(/^(\d{1,2})[.,](\d{1,2})$/);

    if (m) {
        return valido(Math.round(Number(`${m[1]}.${m[2]}`) * 60));
    }

    // `90` -- numero puro e MINUTO, e nao hora.
    //
    // A escolha vem da tela: a celula da folha mostra `1h 30m`, e quem digita
    // "90" ali esta corrigindo aquele numero. Interpretar como 90 horas seria
    // aceitar um valor que a propria validacao recusa logo depois.
    m = texto.match(/^(\d{1,4})$/);

    if (m) {
        return valido(Number(m[1]));
    }

    return null;
}

function valido(minutos) {
    if (!Number.isFinite(minutos) || minutos <= 0 || minutos > MAXIMO_MINUTOS) {
        return null;
    }

    return minutos;
}

/** `90` -> `1h 30m`. Zero e nulo viram string vazia, nao "0m". */
export function formatarDuracao(minutos, { curto = false } = {}) {
    const total = Number(minutos);

    if (!Number.isFinite(total) || total <= 0) {
        return '';
    }

    const horas = Math.floor(total / 60);
    const resto = total % 60;

    if (curto) {
        return horas > 0 ? `${horas}:${String(resto).padStart(2, '0')}` : `0:${String(resto).padStart(2, '0')}`;
    }

    if (horas === 0) {
        return `${resto}m`;
    }

    return resto === 0 ? `${horas}h` : `${horas}h ${resto}m`;
}

/** `2400` -> `40h`. Para capacidade semanal, onde o minuto nao interessa. */
export function formatarHoras(minutos) {
    const total = Number(minutos);

    if (!Number.isFinite(total)) {
        return '';
    }

    const horas = total / 60;

    return Number.isInteger(horas) ? `${horas}h` : `${horas.toFixed(1).replace('.', ',')}h`;
}
